import React, { useEffect, useState, Fragment } from "react";
import { useStore, OPEN_MODAL } from "./Util";
// import PrimaryButton from "components/Buttons/PrimaryButton";
// import SecondaryButton from "components/Buttons/SecondaryButton";
// import DangerButton from "components/Buttons/DangerButton";
import { Dialog, Transition } from "@headlessui/react";
import { packClasses } from "Utils";

export default function ModalRoot(props) {
    const store = useStore();
    const [isOpen, setIsOpen] = useState(false);

    const onClose = () => {
        if (store.onCancel) {
            store.onCancel();
        }
        setIsOpen(false);
    };

    useEffect(() => {
        setIsOpen(store.state === OPEN_MODAL);
    }, [store]);

    return (
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div
                    className={packClasses(
                        "fixed z-10 overflow-y-auto",
                        store.variant === "wide" ? "inset-x-0 top-0" : "inset-0"
                    )}
                >
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className={packClasses(
                                    "relative transform overflow-auto rounded-lg bg-white text-left shadow-xl transition-all sm:my-8",
                                    store.variant === "wide"
                                        ? "w-11/12"
                                        : "sm:w-full sm:max-w-2xl"
                                )}
                                style={{ maxHeight: "95vh" }}
                            >
                                {props.children(store)}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
